import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router'
import { Console } from '@angular/core/src/console';

import { AcessoApiService } from '../../../acessoApi.service'
import { ExibirMenuService } from '../../shared/exibir-menu.service'
import { DadosAcessoService } from '../../../dadosAcesso.service'
import { NotificationsService } from 'angular2-notifications';
import { Event } from '@angular/router/src/events';

@Component({
  selector: 'app-reset-senha',
  templateUrl: './reset-senha.component.html',
  styleUrls: ['./reset-senha.component.css']
})
export class ResetSenhaComponent implements OnInit {

  public codLoja: string = "";
  public confLoja: string = "";
  
  public options = {
    position: ["bottom", "right"],
    timeOut: 5000,
    lastOnBottom: true

  }
  constructor(private exibirItens: ExibirMenuService, private acessoAPI: AcessoApiService, private dadosAcesso: DadosAcessoService, private router: Router, private notificacao: NotificationsService) { 
    if(sessionStorage.getItem('cod_loja') === null){

      this.router.navigate(["/"])
    }
    this.exibirItens.setItensVisiveis(true);

  }

  ngOnInit() {
  }

  ResetarSenha(): void{
      if(this.codLoja !== this.confLoja){

        this.notificacao.error(
          'Códigos de loja diferentes!',
          'Favor verificar dados digitados',
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )

      }else if(this.codLoja === "" || this.confLoja === ""){
        this.notificacao.error(
          'Digite o código!',
          'Favor digitar o código para o reset',
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )

      }else{
        this.acessoAPI.resetarSenha(this.codLoja, this.confLoja).subscribe(
          data => {
            this.notificacao.success(
              'Dados Resetados!',
              data,
              {
                timeOut: 2000,
                showProgressBar: false,
                pauseOnHover: false,
                clickToClose: false,
                maxLength: 2
              }
            )
          },error =>{
            this.notificacao.error(
              'Dados Resetados!',
              error._body,
              {
                timeOut: 2000,
                showProgressBar: false,
                pauseOnHover: false,
                clickToClose: false,
                maxLength: 2
              }
            )

          })
        
 
}}}



// WEBPACK FOOTER //
// ./src/app/pages/administracao/reset-senha/reset-senha.component.ts